import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import {
  Container,
  Service,
  MetaTrackingService
} from '../../../symphony';
import { SubscriptionPlanId } from '../../../shared/public/globalInterfaces/globalInterfaces';
import {
  IGatewayTokenResponse, IPaymentConfirmPayload, IPaymentConfirmationResponse, IStartVtbPaymentPayload, IUpdatePaymentMethodPayload, PaymentApi,
} from '../../../api/public/payment-api';
import { SlApiContext } from '../../../api/private/api-context';
import { SlErrorHandlerService } from '../../../api/public/error-handling';
import { PaymentProvider } from '../../../api/public/subscription-api';

export interface ISubscriptionHistory {
  cancelDate: string;
  paymentPlanId: SubscriptionPlanId;
  subscriptionDate: string;
  trialExpiredDate: string;
}

@Service()
export class SlPaymentApiService {
  private paymentApi = Container.take('global', PaymentApi);

  private gatewayTokens: Observable<IGatewayTokenResponse>;

  private metaTrackingService = Container.take('global', MetaTrackingService);

  private handleErrorCatching = Container.take(
    SlApiContext,
    SlErrorHandlerService,
  ).handleErrorCatching;

  public gatewayTokenStream(): Observable<IGatewayTokenResponse> {
    if (!this.gatewayTokens) {
      this.gatewayTokens = this.paymentApi
        .getGatewayToken()
        .pipe(shareReplay(4), this.handleErrorCatching(true, {}, null));
    }
    return this.gatewayTokens;
  }

  public subscribe(
    payload: IPaymentConfirmPayload,
  ): Observable<IPaymentConfirmationResponse> {
    return this.paymentApi.subscribe(payload).pipe(
      tap(() => {
        const { product } = payload;
        if (product.trialDays > 0) {
          this.metaTrackingService.trackTrialStarted(product);
        } else {
          this.metaTrackingService.trackPurchase(product);
        }
      }),
    );
  }

  public updatePaymentMethod(payload: IUpdatePaymentMethodPayload): Observable<any> {
    return this.paymentApi.updatePaymentMethod(payload);
  }

  public startVtbPayment(payload: IStartVtbPaymentPayload): Observable<{ formUrl: string; }> {
    return this.paymentApi.startVtbPayment(payload);
  }

  public getProductInfo(provider: PaymentProvider, productId: string): Observable<any[]> {
    return this.paymentApi.getProductInfo(provider, productId);
  }
}
